import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CookieSettings from './CookieSettings';
import useCookieConsent from '../../hooks/useCookieConsent';

const CookieBanner = () => {
  const { consent, hasConsent, mounted, updateConsent } = useCookieConsent();
  const { t, i18n } = useTranslation();
  const [showSettings, setShowSettings] = useState(false);

  const isSpanish = i18n.language !== 'en';

  // Permitir reabrir el gestor de cookies desde cualquier punto (p. ej. el footer)
  useEffect(() => {
    const handleOpenSettings = () => setShowSettings(true);
    window.addEventListener('open-cookie-settings', handleOpenSettings);
    return () => window.removeEventListener('open-cookie-settings', handleOpenSettings);
  }, []);

  const acceptAll = () => {
    updateConsent({
      necessary: true,
      analytics: true,
      marketing: false
    });
  };

  const rejectAll = () => {
    updateConsent({
      necessary: true,
      analytics: false,
      marketing: false
    });
  };

  const openSettings = () => {
    setShowSettings(true);
  };

  const handleSettingsSave = (preferences) => {
    updateConsent(preferences);
    setShowSettings(false);
  };

  // No renderizar nada hasta que se haya leído localStorage (evita hydration mismatch)
  if (!mounted) return null;

  // Con consentimiento ya dado, solo se muestra el modal si el usuario reabre el gestor
  if (hasConsent) {
    return showSettings ? (
      <CookieSettings
        onSave={handleSettingsSave}
        onClose={() => setShowSettings(false)}
        initialPreferences={consent}
      />
    ) : null;
  }

  return (
    <>
      {/* Diseño B2B (nov-2026): azul marino, botones rectos. «Rechazar» y «Aceptar todas»
          con el mismo peso visual (criterio de la AEPD: rechazar tan fácil como aceptar). */}
      <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,0.25)]" style={{ backgroundColor: '#0b1d39' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex-1">
              <p className="text-sm text-slate-300 leading-relaxed">
                {isSpanish
                  ? 'Utilizamos cookies técnicas necesarias y analíticas para mejorar su experiencia de navegación.'
                  : 'We use necessary technical and analytics cookies to improve your browsing experience.'}
                {' '}
                <Link to="/cookies" className="text-white underline underline-offset-2 decoration-white/40 hover:decoration-white ml-1">
                  {isSpanish ? 'Más información sobre cookies' : 'More information about cookies'}
                </Link>
              </p>
            </div>
            <div className="grid grid-cols-2 gap-2 w-full sm:flex sm:w-auto sm:gap-3">
              <button
                onClick={openSettings}
                className="col-span-2 order-last sm:order-none px-4 py-2.5 text-sm font-semibold border border-white/40 text-white hover:bg-white/10 hover:border-white/70 transition-colors"
              >
                {isSpanish ? 'Configurar' : 'Settings'}
              </button>
              <button
                onClick={rejectAll}
                className="px-5 py-2.5 text-sm font-semibold bg-white text-[#0b1d39] hover:bg-blue-50 transition-colors"
              >
                {isSpanish ? 'Rechazar' : 'Reject'}
              </button>
              <button
                onClick={acceptAll}
                className="px-5 py-2.5 text-sm font-semibold bg-white text-[#0b1d39] hover:bg-blue-50 transition-colors"
              >
                {isSpanish ? 'Aceptar todas' : 'Accept all'}
              </button>
            </div>
          </div>
        </div>
      </div>

      {showSettings && (
        <CookieSettings
          onSave={handleSettingsSave}
          onClose={() => setShowSettings(false)}
        />
      )}
    </>
  );
};

export default CookieBanner;